(() => {
  const root=document.querySelector('.nf-learn-clinical');if(!root)return;
  let opener;
  const dialog=root.querySelector('[data-clinical-dialog]');
  const sizeGraphs=()=>{
    root.querySelectorAll('.nf-clinical-chart').forEach(svg=>{
      const width=svg.getBoundingClientRect().width;
      if(width>0)svg.style.setProperty('--chart-font-size',Math.max(14,12*svg.viewBox.baseVal.width/width).toFixed(2)+'px');
      graphResize.observe(svg.parentElement);
    });
  };
  const graphResize=new ResizeObserver(sizeGraphs);
  new MutationObserver(sizeGraphs).observe(root,{childList:true,subtree:true});
  sizeGraphs();
  root.querySelectorAll('[data-chart-information]').forEach(button=>button.addEventListener('click',()=>{
    opener=button;
    const terminal=button.parentElement.textContent.includes('Terminal hair');
    dialog.querySelector('[data-terminal-explanation]').hidden=!terminal;
    dialog.querySelector('[data-investigator-explanation]').hidden=terminal;
    dialog.showModal();
  }));
  dialog.addEventListener('close',()=>opener?.focus());
})();
